import { Children, isValidElement, ReactNode } from 'react'
import cx from 'classnames'

interface StepProps {
  title?: ReactNode
  subTitle?: ReactNode
  description?: ReactNode
  icon?: ReactNode
  status?: 'wait' | 'process' | 'finish' | 'error'
  className?: string
  'data-testid'?: string
  [key: string]: unknown
}

// Rendered by the Steps parent — props are read directly
export const Step = (_props: StepProps): null => null

const StepsComponent = ({ children }: { children: ReactNode }) => {
  const steps = Children.toArray(children).filter(isValidElement)

  return (
    <div className="flex flex-col">
      {steps.map((step, i) => {
        const {
          title,
          subTitle,
          description,
          icon,
          className,
          'data-testid': dataTestId,
        } = step.props as StepProps
        const isLast = i === steps.length - 1

        return (
          <div
            key={i}
            className={cx('flex', className)}
            data-testid={dataTestId}
          >
            <div className="flex flex-col items-center w-6 shrink-0">
              <span className="flex items-center justify-center text-current">
                {icon}
              </span>
              {!isLast && (
                <div className="w-px flex-1 bg-coolGray-300 mt-1 min-h-[8px]" />
              )}
            </div>
            <div className="ml-2 leading-snug mt-0.5 pb-3">
              <div className="font-medium">{title}</div>
              {subTitle && (
                <div className="text-sm text-coolGray-500">{subTitle}</div>
              )}
              {description && (
                <div className="text-sm text-coolGray-400">{description}</div>
              )}
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default StepsComponent
